import { render, staticRenderFns } from "./industryPage.vue?vue&type=template&id=292031ba&scoped=true&"
import script from "./industryPage.vue?vue&type=script&lang=js&"
export * from "./industryPage.vue?vue&type=script&lang=js&"
import style0 from "./industryPage.vue?vue&type=style&index=0&id=292031ba&prod&lang=scss&scoped=true&"
import style1 from "./industryPage.vue?vue&type=style&index=1&id=292031ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292031ba",
  null
  
)

export default component.exports